import {
    Checkbox,
    FormControlLabel,
    styled,
    TextField
} from "@mui/material";

import { useTarefa } from "../../../../../contexts/TarefaContext";
import { ITarefaArquivos } from "../../../../../types/tarefa";
import { BFGridContainer, BFGridOneLine } from "../../../../BFGrid";
import { v4 as uuidv4 } from 'uuid';
import { BFChange, BFChangeInput } from "../../../../../types/components";
import { useState } from "react";

const BFFormControlLabel = styled(FormControlLabel)({
    marginBottom: '16px'
});

const BackupArquivos = () => {
    const [tarefa, setTarefa] = useTarefa();

    const configuracaoInicial: ITarefaArquivos = tarefa.arquivos ? tarefa.arquivos : {
        id: uuidv4(),
        pastaOrigem: "",
        incluirSubPastas: true,
        pastaDestino: ""
    };

    const [tarefaArquivos, setTarefaArquivos] = useState<ITarefaArquivos>({ ...configuracaoInicial });

    function handlePastaOrigem(event: BFChange): void {
        mudarEstadoTarefa({ ...tarefaArquivos, pastaOrigem: event.target.value });
    }

    function handlePastaDestino(event: BFChange): void {
        mudarEstadoTarefa({ ...tarefaArquivos, pastaDestino: event.target.value });
    }

    function handleSelecionarSubPastas(event: BFChangeInput): void {
        event.preventDefault();
        mudarEstadoTarefa({ ...tarefaArquivos, incluirSubPastas: event.target.checked });
    }

    function mudarEstadoTarefa(novaConfiguracao: ITarefaArquivos): void {
        setTarefaArquivos(novaConfiguracao);
        setTarefa({ ...tarefa, arquivos: novaConfiguracao });
    }

    return (
        <BFGridContainer>
            <BFGridOneLine>
                <TextField
                    fullWidth
                    id="pastaOrigem"
                    name="pastaOrigem"
                    label="Pasta Origem"
                    variant="outlined"
                    required
                    value={tarefaArquivos.pastaOrigem}
                    onChange={handlePastaOrigem} />
            </BFGridOneLine>
            <BFGridOneLine>
                <BFFormControlLabel
                    control={<Checkbox
                        checked={tarefaArquivos.incluirSubPastas}
                        onChange={handleSelecionarSubPastas} />}
                    label="Incluir sub pastas" />
            </BFGridOneLine>

            <BFGridOneLine>
                <TextField
                    fullWidth
                    id="pastaDestino"
                    name="pastaDestino"
                    label="Pasta Destino"
                    variant="outlined"
                    required
                    value={tarefaArquivos.pastaDestino}
                    onChange={handlePastaDestino} />
            </BFGridOneLine>
        </BFGridContainer>
    )
}

export default BackupArquivos;